import React from 'react'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Divider from '@material-ui/core/Divider'
import { makeStyles } from '@material-ui/core/styles'

import { COLORS } from 'styles'

import { CardDashboad } from '../components'

const useStyles = makeStyles({
  title: {
    color: COLORS.FONT,
  },
  divider: {
    backgroundColor: COLORS.BASE,
  },
})

interface DataUserTests {
  completed: number
  completed_previous: number
}

interface PropsUserTests {
  data: DataUserTests
}

const UserTests: React.FC<PropsUserTests> = ({ data }) => {
  const classes = useStyles()

  return (
    <>
      <Grid item xs={12}>
        <Typography variant="h6" component="h2" className={classes.title}>
          Tests de Usuario
        </Typography>
        <Divider className={classes.divider} />
      </Grid>
      <Grid item xs={4}>
        <CardDashboad
          value={data.completed}
          description="Tests Completados"
          value_previous={data.completed_previous}
          isPercent={false}
        />
      </Grid>
    </>
  )
}

export { UserTests }
